import React, { useEffect, useState, useRef } from "react";
import { Typography } from "@material-ui/core";
import { Image } from "react-bootstrap";
import parse from "html-react-parser";
import { useReactToPrint } from "react-to-print";
import html2pdf from "html2pdf.js";
import { getDelivery } from "../../services/inventory/deliveryService";
import { formatDate } from "../../utils/utils";
import {
  getSharedDocuments,
  uploadSharedDocument,
} from "../../services/commons";
import DialogLayout from "./DialogLayout";
import { DialogActions } from "@material-ui/core";
import { CustomOutlinedDisabledTextField } from "./Forms";
import copy from "clipboard-copy";
import BootstrapTooltip from "./BootstrapTooltip";
import Swal from "sweetalert2";
import { DateTime } from "luxon";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
import { getSoDeliveryDetail } from "../../services/sales/salesDeliveryService";
const CustomPrintOutDelivery = ({
  title = "DELIVERY NOTE",
  deliveryID = 0,
  currentDateTime = DateTime.now(),
}) => {
  const { companyProfile, reload } = useGlobalData();
  const [delivery, setDelivery] = useState({
    ID: 0,
    customer: {
      customerName: "",
    },
    currency: {
      currencyCode: "",
    },
    deliveryItem: [],
    deliveryServiceData: [],
  });
  const [openSharedDocument, setOpenSharedDocument] = useState(false);
  const [sharedDocumentLink, setSharedDocumentLink] = useState("");
  const timestamp = DateTime.now().toFormat("yyyy-MM-dd, hh:mm a ZZZZZ (ZZZZ)");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [isCopySucceed, setIsCopySucceed] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState("");

  useEffect(() => {
    getDeliveryData(deliveryID);
    setFrom(companyProfile.companyName);
    getSharedDocumentData("DELV", delivery.ID);
  }, [reload]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle:
      "@page { size: ledger; !important; } @media print { body { -webkit-print-color-adjust: exact; !important; } }",
    documentTitle: `Delivery Note_${from}_${to}_${formatDate(
      currentDateTime,
      true
    )}`,
  });
  const handleDownloadPDF = () => {
    var opt = {
      margin: 0,
      filename: `Delivery Note_${from}_${to}_${formatDate(
        currentDateTime,
        true
      )}.pdf`,
      image: { type: "jpeg", quality: 1 },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      html2canvas: {
        scale: 2,
        letterRendering: true,
        allowTaint: true,
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: "ledger",
        orientation: "portrait",
        putOnlyUsedFonts: true,
        compress: true,
      },
    };
    var element = componentRef.current;
    html2pdf()
      .from(element)
      .set(opt)
      .toPdf()
      .get("pdf")
      .save();
  };
  const handleSharePDF = () => {
    let fileName = `Delivery Note_${from}_${to}_${formatDate(
      currentDateTime,
      true
    )}.pdf`;
    let fileNameConverted = fileName.replace(/ /g, "").replace(/:/g, "");
    var opt = {
      margin: 0,
      filename: `Delivery Note_${from}_${to}_${formatDate(
        currentDateTime,
        true
      )}.pdf`,
      image: { type: "jpeg", quality: 1 },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      html2canvas: {
        scale: 2,
        letterRendering: true,
        allowTaint: true,
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: "ledger",
        orientation: "portrait",
        putOnlyUsedFonts: true,
        compress: true,
      },
    };
    var element = componentRef.current;
    html2pdf()
      .from(element)
      .set(opt)
      .toPdf()
      .get("pdf")
      .output("datauristring")
      .then(function(pdf) {
        const filesData = new FormData();
        const preBlob = dataURItoBlob(pdf);
        const file = new File([preBlob], fileNameConverted, {
          type: "application/pdf",
        });
        filesData.append("files[]", file);
        filesData.append("docID", delivery.ID);
        filesData.append("docType", "DELV");
        uploadSharedDocument(filesData).then((response) => {
          getSharedDocumentData("DELV", delivery.ID);
          setOpenSharedDocument(true);
        });
      });
  };

  function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI
      .split(",")[0]
      .split(":")[1]
      .split(";")[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  return (
    <React.Fragment>
      <div className="row justify-content-center py-2 px-5 py-md-2 px-md-5">
        <div className="col-md-12">
          <div className="d-flex justify-content-between">
            <button
              type="button"
              className="btn btn-label-success btn-md btn-pill btn-bold"
              onClick={handleDownloadPDF}
            >
              <i className="fas fa-cloud-download-alt"></i>
              Download Delivery Note
            </button>
            <button
              type="button"
              className="btn btn-label-primary btn-md btn-pill btn-bold"
              onClick={handleSharePDF}
            >
              <i className="fas fa-share-alt"></i>
              Share Delivery Note
            </button>
            <button
              type="button"
              className="btn btn-label-info btn-md btn-pill btn-bold"
              onClick={handlePrint}
            >
              <i className="fas fa-print"></i>
              Print Delivery Note
            </button>
          </div>
        </div>
      </div>
      <div ref={componentRef} className="d-flex flex-column-fluid">
        <div className="container">
          <div className="card card-custom overflow-hidden border-0">
            <div className="card-body p-0">
              <div className="row justify-content-center pt-5 pb-3 px-5 pt-md-5 pb-md-3 px-md-5">
                <div className="col-md-12">
                  <div className="d-flex justify-content-between flex-row flex-xl-row flex-lg-row flex-md-row flex-sm-column">
                    <h1 className="display-5 kt-font-bolder text-dark mb-3 mr-1">
                      {title}
                    </h1>
                    <div className="d-flex flex-column align-items-md-end px-0 ml-1">
                      <div className="mb-3">
                        <Image
                          src={
                            companyProfile.companyProfileLogo.length > 0
                              ? companyProfile.companyProfileLogo[0].imagePath.includes(
                                  "?"
                                )
                                ? `${companyProfile.companyProfileLogo[0].imagePath}&v=${timestamp}`
                                : `${companyProfile.companyProfileLogo[0].imagePath}?v=${timestamp}`
                              : "/media/logos/logo-form-header.png"
                          }
                          style={{
                            maxHeight: "9rem",
                            maxWidth: "18rem",
                          }}
                          alt="Company Profile Logo"
                          fluid
                          crossOrigin="anonymous"
                        />
                      </div>
                      <div
                        className="d-flex flex-column align-items-md-end text-wrap"
                        style={{
                          maxWidth: "300px",
                        }}
                      >
                        <Typography className="kt-font-bolder text-dark text-md-right text-uppercase">
                          {companyProfile.companyName}
                        </Typography>
                        <Typography className="kt-font-bold text-muted text-md-right">
                          {companyProfile.fullAddress}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center bg-light py-3 px-5 py-md-3 px-md-5">
                <div className="col-md-12">
                  <div className="d-flex justify-content-between">
                    <div
                      className="d-flex flex-column flex-root text-wrap"
                      style={{
                        width: "200px",
                      }}
                    >
                      <Typography className="kt-font-bolder text-dark mb-2">
                        DELIVERY NOTE NO.
                      </Typography>
                      <Typography className="kt-font-bold text-muted mb-2">
                        {delivery.ID}
                      </Typography>
                      <Typography className="kt-font-bolder text-dark mb-2">
                        DELIVERY DATE.
                      </Typography>
                      <Typography className="kt-font-bold text-muted mb-2">
                        {formatDate(delivery.deliveryDate)}
                      </Typography>
                      <Typography className="kt-font-bolder text-dark mb-2">
                        DELIVERY RECEIPT NO.
                      </Typography>
                      <Typography className="kt-font-bold text-muted mb-2">
                        {delivery.resiNo}
                      </Typography>
                      <Typography className="kt-font-bolder text-dark mb-2">
                        DELIVERY TEAM.
                      </Typography>
                      <Typography className="kt-font-bold text-muted mb-2">
                        {delivery.driverName}
                      </Typography>
                    </div>
                    <div
                      className="d-flex flex-column flex-root text-wrap"
                      style={{
                        width: "200px",
                      }}
                    >
                      <Typography className="kt-font-bolder text-dark mb-2">
                        INVOICE TO.
                      </Typography>
                      {delivery.customerID > 0 ? (
                        <React.Fragment>
                          <Typography className="kt-font-bold text-muted">
                            <strong>{delivery.customer.customerName}</strong>
                          </Typography>
                          {delivery.salesOrderID > 0 ||
                          delivery.salesReturnID > 0 ? (
                            <Typography className="kt-font-bold text-muted">
                              {delivery.salesOrder.soBillingAddress.fullAddress}
                            </Typography>
                          ) : (
                            <Typography className="kt-font-bold text-muted">
                              {delivery.customer.fullAddress}
                            </Typography>
                          )}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <Typography className="kt-font-bold text-muted">
                            -
                          </Typography>
                        </React.Fragment>
                      )}
                    </div>
                    <div
                      className="d-flex flex-column flex-root text-wrap"
                      style={{
                        width: "200px",
                      }}
                    >
                      <Typography className="kt-font-bolder text-dark mb-2">
                        SHIP TO.
                      </Typography>
                      {delivery.recipient ? (
                        <React.Fragment>
                          <Typography className="kt-font-bold text-muted">
                            <strong>{delivery.recipient}</strong>
                          </Typography>
                          <Typography className="kt-font-bold text-muted">
                            {delivery.fullAddress}
                          </Typography>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <Typography className="kt-font-bold text-muted">
                            -
                          </Typography>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center py-3 px-5 py-md-3 px-md-5">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        {delivery.deliveryItem &&
                        delivery.deliveryItem.length > 0 ? (
                          <tr>
                            <th style={{ width: "50%" }} className="pl-0">
                              <Typography className="kt-font-bolder text-muted">
                                ITEM NAME
                              </Typography>
                            </th>
                            <th style={{ width: "25%" }}>
                              <Typography className="kt-font-bolder text-muted">
                                QTY
                              </Typography>
                            </th>
                            <th style={{ width: "25%" }} className="pr-0">
                              <Typography className="kt-font-bolder text-muted">
                                BATCH ID
                              </Typography>
                            </th>
                          </tr>
                        ) : null}
                      </thead>
                      <tbody>
                        {delivery.deliveryItem &&
                        delivery.deliveryItem.length > 0 ? (
                          <React.Fragment>
                            {delivery.deliveryItem.map((item, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <tr className="kt-font-bolder border-bottom-0">
                                    <td className="pl-0 py-2">
                                      <Typography className="kt-font-bold text-dark">
                                        {item.itemCode} {item.itemName}
                                      </Typography>
                                    </td>
                                    <td className="py-2">
                                      <Typography className="kt-font-bold text-dark">
                                        {item.qty} {item.uomName}
                                      </Typography>
                                    </td>
                                    <td className="pr-0 py-2">
                                      <Typography className="kt-font-bold text-dark">
                                        {item.batchID}
                                      </Typography>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            })}
                          </React.Fragment>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center py-3 px-5 py-md-3 px-md-5">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        {delivery.deliveryService &&
                        delivery.deliveryService.length > 0 ? (
                          <tr>
                            <th style={{ width: "50%" }} className="pl-0">
                              <Typography className="kt-font-bolder text-muted">
                                SERVICE NAME
                              </Typography>
                            </th>
                            <th style={{ width: "50%" }} className="pr-0">
                              <Typography className="kt-font-bolder text-muted">
                                QTY
                              </Typography>
                            </th>
                          </tr>
                        ) : null}
                      </thead>
                      <tbody>
                        {delivery.deliveryService &&
                        delivery.deliveryService.length > 0 ? (
                          <React.Fragment>
                            {delivery.deliveryService.map((service, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <tr className="kt-font-bolder border-bottom-0">
                                    <td className="pl-0 py-2">
                                      <Typography className="kt-font-bold text-dark">
                                        {service.serviceCode}{" "}
                                        {service.serviceName}
                                      </Typography>
                                    </td>
                                    <td className="pr-0 py-2">
                                      <Typography className="kt-font-bold text-dark">
                                        {service.qty} {service.uom.uom}
                                      </Typography>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            })}
                          </React.Fragment>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center bg-light py-3 px-5 py-md-3 px-md-5">
                <div className="col-md-12">
                  <div className="d-flex justify-content-between flex-row flex-xl-row flex-lg-row flex-md-row flex-sm-column">
                    <div className="d-flex flex-column mb-3 mb-md-0 mr-1">
                      <div className="kt-font-bolder text-muted mb-2">
                        <Typography className="kt-font-bolder text-muted">
                          NOTES OR SPECIAL INSTRUCTIONS.
                        </Typography>
                      </div>
                      <div className="kt-font-bold text-dark">
                        {delivery.note ? (
                          <Typography
                            className="kt-font-bold text-dark text-wrap"
                            style={{ maxWidth: "420px" }}
                          >
                            {parse(delivery.note)}
                          </Typography>
                        ) : (
                          <Typography
                            className="kt-font-bold text-dark text-wrap"
                            style={{ maxWidth: "420px" }}
                          >
                            -
                          </Typography>
                        )}
                      </div>
                    </div>
                    <div className="d-flex flex-column">
                      <Typography className="kt-font-bolder text-muted mb-5">
                        GOODS RECEIVED BY:
                      </Typography>
                      <Typography className="kt-font-bold text-muted mb-1">
                        Signature ________________________________
                      </Typography>
                      <Typography className="kt-font-bold text-muted mb-1">
                        Name:
                      </Typography>
                      <Typography className="kt-font-bold text-muted mb-1">
                        Date:
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center pt-3 pb-5 px-5 pt-md-3 pb-md-5 px-md-5">
                <div className="col-md-12">
                  <div className="d-flex flex-column">
                    <div className="d-flex flex-column mb-2 mt-2">
                      <div className="kt-font-bold text-muted text-center">
                        <Typography className="kt-font-bold text-muted text-center">
                          If you have any questions about this Delivery Note,
                          please contact{" "}
                          <strong>{companyProfile.companyName}</strong>
                        </Typography>
                      </div>
                      <div className="kt-font-bold text-muted text-center">
                        <Typography className="kt-font-bold text-muted text-center">
                          <strong>{companyProfile.fullAddress}</strong>
                        </Typography>
                      </div>
                      <div className="kt-font-bold text-muted text-center">
                        <Typography className="kt-font-bold text-muted text-center">
                          Tel: <strong>{companyProfile.phone}</strong>, Email:{" "}
                          <strong>{companyProfile.email}</strong>, Website:{" "}
                          <strong>{companyProfile.website}</strong>
                        </Typography>
                      </div>
                    </div>
                    <div className="d-flex flex-column mb-2 mt-2">
                      <div className="kt-font-bold text-muted text-center">
                        <Typography className="kt-font-bold text-muted text-center">
                          Thank you for your business!
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openSharedDocument}
        title={"Shared Document Link"}
        onCloseDialog={() => {
          setOpenSharedDocument(false);
        }}
        //fullScreen={false}
        maxWIdth="sm"
      >
        <React.Fragment>
          <CustomOutlinedDisabledTextField
            label="Shared Document URL Link"
            value={sharedDocumentLink}
          />
        </React.Fragment>
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSharedDocument(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
          <button
            type="button"
            className="btn btn-success btn-md btn-pill btn-bold"
            onClick={(e) => {
              e.preventDefault();
              let message = sharedDocumentLink;
              if (whatsappNumber === "") {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Failed",
                  text: "Lead / Customer Whatsapp Number cannot be empty",
                  icon: "error",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              } else {
                // Regex expression to remove all characters which are NOT alphanumeric
                let number = whatsappNumber
                  .replace(/[^\w\s]/gi, "")
                  .replace(/ /g, "");

                // Appending the phone number to the URL
                let url = `https://web.whatsapp.com/send?phone=${number}`;

                // Appending the message to the URL by encoding it
                url += `&text=${encodeURI(message)}&app_absent=0`;

                // Open our newly created URL in a new tab to send the message
                window.open(url);
              }
            }}
          >
            <i className="flaticon-whatsapp"></i>
            Send To Whatsapp
          </button>
          <BootstrapTooltip
            title="URL Copied"
            open={isCopySucceed}
            onClose={() => {
              setIsCopySucceed(false);
            }}
          >
            <button
              type="button"
              className="btn btn-dark btn-md btn-pill btn-bold"
              onClick={() => {
                copy(sharedDocumentLink).then(() => {
                  setIsCopySucceed(true);
                });
              }}
            >
              <i className="fas fa-copy"></i>
              Copy To Clipboard
            </button>
          </BootstrapTooltip>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  async function getDeliveryData(deliveryID) {
    if (deliveryID > 0) {
      const response = await getSoDeliveryDetail(deliveryID);
      const { data } = response.data;
      setDelivery(data.soDelivery);
      if (data.soDelivery.customerID > 0) {
        setTo(data.soDelivery.customer.customerName);
        setWhatsappNumber(data.soDelivery.customer.addressPhone);
      }
    }
  }

  async function getSharedDocumentData(docType, docID) {
    const response = await getSharedDocuments(docType, docID);
    const { data } = response.data;
    let sharedDocuments = data.sharedDocuments;
    if (sharedDocuments.length > 0) {
      setSharedDocumentLink(sharedDocuments[0].filePath);
    }
  }
};

export default CustomPrintOutDelivery;
